import React from 'react';
import { useSelector } from 'react-redux';
import * as S from './drawer-cart-item-qty-buttons.styles';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { selectHideQtyPicker } from '../../../../redux/config/config.selectors';
import { useTranslation } from 'react-i18next';

const DrawerCartItemQtyButtons = ({
  handleIncrement,
  handleDecrement,
  quantity,
  modifyQtyType,
  modifyingQtyItemIds,
  title,
}) => {
  const hideQtyPicker = useSelector(selectHideQtyPicker);
  const { t } = useTranslation();

  const newHandleIncrement = () => {
    if (modifyQtyType === '+' && modifyingQtyItemIds.length > 0) return;
    handleIncrement();
  };

  const newHandleDecrement = () => {
    if (modifyQtyType === '-' && modifyingQtyItemIds.length > 0) return;
    handleDecrement();
  };

  return (
    <S.QtyButtons>
      {!hideQtyPicker && (
        <S.QtyButton
          data-testid="DrawerCartItem.QtyButton.Increase"
          onClick={newHandleIncrement}
          aria-label={t('checkout.items.quantity.increment', {
            title,
            quantity,
          })}
        >
          <AddIcon fontSize="small" />
        </S.QtyButton>
      )}

      <S.Quantity>{quantity}</S.Quantity>

      {!hideQtyPicker && (
        <S.QtyButton
          data-testid="DrawerCartItem.QtyButton.Decrease"
          onClick={newHandleDecrement}
          aria-label={t('checkout.items.quantity.decrement', {
            title,
            quantity,
          })}
        >
          <RemoveIcon fontSize="small" />
        </S.QtyButton>
      )}
    </S.QtyButtons>
  );
};

export default DrawerCartItemQtyButtons;
